import { render, staticRenderFns } from "./LabelFirmware.vue?vue&type=template&id=b74ac6d6&"
import script from "./LabelFirmware.vue?vue&type=script&lang=js&"
export * from "./LabelFirmware.vue?vue&type=script&lang=js&"
import style0 from "./LabelFirmware.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VDataTable,VPagination,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b74ac6d6')) {
      api.createRecord('b74ac6d6', component.options)
    } else {
      api.reload('b74ac6d6', component.options)
    }
    module.hot.accept("./LabelFirmware.vue?vue&type=template&id=b74ac6d6&", function () {
      api.rerender('b74ac6d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Firmware/LabelFirmware.vue"
export default component.exports